<template>
  <div>
    <ul
      class="practice-item-option"
      ref="option"
      v-if="optionType == 1 || optionType == 2"
    >
      <li v-if="data.a">
        <label @click="fn2">
          <input
            :name="data.exerId"
            :type="optionType == 1 ? 'radio' : 'checkbox'"
            :checked="isChecked('A')"
            :disabled="disabled"
            value="A"
          />
          <i>A</i>
          <div class="item-text" v-latex="data.a"></div>
        </label>
      </li>
      <li v-if="data.b">
        <label @click="fn2">
          <input
            :name="data.exerId"
            :type="optionType == 1 ? 'radio' : 'checkbox'"
            :checked="isChecked('B')"
            :disabled="disabled"
            value="B"
          />
          <i>B</i>
          <div class="item-text" v-latex="data.b"></div>
        </label>
      </li>
      <li v-if="data.c">
        <label @click="fn2">
          <input
            :name="data.exerId"
            :type="optionType == 1 ? 'radio' : 'checkbox'"
            :checked="isChecked('C')"
            :disabled="disabled"
            value="C"
          />
          <i>C</i>
          <div class="item-text" v-latex="data.c"></div>
        </label>
      </li>
      <li v-if="data.d">
        <label @click="fn2">
          <input
            :name="data.exerId"
            :type="optionType == 1 ? 'radio' : 'checkbox'"
            :checked="isChecked('D')"
            :disabled="disabled"
            value="D"
          />
          <i>D</i>
          <div class="item-text" v-latex="data.d"></div>
        </label>
      </li>
      <li v-if="data.e">
        <label @click="fn2">
          <input
            :name="data.exerId"
            :type="optionType == 1 ? 'radio' : 'checkbox'"
            :checked="isChecked('E')"
            :disabled="disabled"
            value="E"
          />
          <i>E</i>
          <div class="item-text" v-latex="data.e"></div>
        </label>
      </li>
      <li v-if="data.f">
        <label @click="fn2">
          <input
            :name="data.exerId"
            :type="optionType == 1 ? 'radio' : 'checkbox'"
            :checked="isChecked('F')"
            :disabled="disabled"
            value="F"
          />
          <i>F</i>
          <div class="item-text" v-latex="data.f"></div>
        </label>
      </li>
      <li v-if="data.g">
        <label @click="fn2">
          <input
            :name="data.exerId"
            :type="optionType == 1 ? 'radio' : 'checkbox'"
            :checked="isChecked('G')"
            :disabled="disabled"
            value="G"
          />
          <i>G</i>
          <div class="item-text" v-latex="data.g"></div>
        </label>
      </li>
      <li v-if="data.h">
        <label @click="fn2">
          <input
            :name="data.exerId"
            :type="optionType == 1 ? 'radio' : 'checkbox'"
            :checked="isChecked('H')"
            :disabled="disabled"
            value="H"
          />
          <i>H</i>
          <div class="item-text" v-latex="data.h"></div>
        </label>
      </li>
    </ul>
    <div v-else class="practice-item-option">
      <div>
        <Input
          maxlength="1000"
          show-word-limit
          type="textarea"
          v-model="userKey"
          :rows="3"
          @on-change="fn2"
          :readonly="disabled"
          placeholder="请输入您的答案"
        />
      </div>
      <div
        v-if="
          scoreMethod === 1 || scoreMethod === 2 || practiceType !== 'simexam'
        "
        class="ask-action clearfix"
        style="margin-top: 6px"
      >
        <Upload
          :action="uploaderUrl"
          :headers="uploaderHeaer"
          :data="uploaderData"
          :max-size="2048"
          :before-upload="handleBefore"
          :on-success="handleSuccess"
          :show-upload-list="false"
          :disabled="disabled"
          class="fl"
        >
          <!-- <Icon custom="ich-icon ich-icon-image" /> -->
          <div
            style="
              width: 60px;
              height: 60px;
              text-align: center;
              border: 1px dashed #999;
              border-radius: 8px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
            "
          >
            <!-- <Icon type="ios-add" /> -->
            <Icon type="md-add" />
            <p style="font-size: 12px">上传图片</p>
          </div>
        </Upload>
      </div>
      <div class="ask-image clearfix">
        <span v-for="(item, index) in picFileList" :key="index">
          <a
            v-if="!disabled"
            href="javascript:;"
            title="删除图片"
            @click="handleRemove(index)"
            >×</a
          >
          <a
            :href="item"
            target="blank"
            title="查看原图"
            style="
              display: block;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              background: transparent;
              width: 26px;
              height: 26px;
              z-index: 10;
            "
          >
            <Icon
              type="md-eye"
              style="
                background: transparent;
                font-size: 26px;
                color: #fe3416;
                z-index: 10;
              "
            />
          </a>
          <i></i>
          <!-- <img :src="concatImageUrl(item, 73, 73, true)" /> -->
          <img :src="`${item}?x-oss-process=image/resize,m_fill,w_73,h_73`" />
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { siteMixin } from '../../utils/mixin';
export default {
  mixins: [siteMixin],
  props: {
    value: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    optionType: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    //评分方式，模考用于是学生自评(1)，还是老师评分(2),(3)&(4)AI评分
    scoreMethod: {
      type: Number,
      default: 1,
    },
    practiceType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      userKey: this.value,
      uploaderUrl: process.env.VUE_APP_API_URL + '/api/pc/upload',
      uploaderHeaer: {
        Authorization: 'Beego aHVhaGFuOmJlZWdvMjAxNQ==',
      },
      uploaderData: {
        dir: 'APPIMG',
      },
      picFileList: [],
    };
  },
  mounted() {
    //console.log("ddddd",this.data);
    this.initPicData();
  },
  methods: {
    fn2() {
      let userKey = '';
      if (this.optionType == 1 || this.optionType == 2) {
        const inputList = this.$refs.option.querySelectorAll('input:checked');
        //if (inputList.length == 0) return;
        inputList.forEach(item => {
          userKey += item.value;
        });
      } else {
        userKey = this.userKey;
      }
      this.$emit('input', userKey);
      this.$emit('getCurrentDate', this.data);
    },
    isChecked(option) {
      if (this.data.userKey == '') return false;
      if (this.data.userKey.indexOf(' ') > -1) return false;
      return this.data.userKey.indexOf(option) > -1;
    },
    initPicData() {
      if (this.data.userKeyImg1) {
        this.picFileList.push(this.data.userKeyImg1);
      }
      if (this.data.userKeyImg2) {
        this.picFileList.push(this.data.userKeyImg2);
      }
      if (this.data.userKeyImg3) {
        this.picFileList.push(this.data.userKeyImg3);
      }
    },
    handleBefore(file) {
      if (this.picFileList.length >= 3) {
        this.$Message.error('最多上传3张图片');
        return false;
      }
    },
    handleRemove(index) {
      this.picFileList.splice(index, 1);
      this.setKeyPicValue();
    },
    handleSuccess(res, file, fileList) {
      if (res.Status) {
        this.picFileList.push(res.imgUrl);
        this.setKeyPicValue();
      }
    },
    setKeyPicValue() {
      this.data.userKeyImg1 =
        this.picFileList.length >= 1 ? this.picFileList[0] : '';
      this.data.userKeyImg2 =
        this.picFileList.length >= 2 ? this.picFileList[1] : '';
      this.data.userKeyImg3 =
        this.picFileList.length >= 3 ? this.picFileList[2] : '';
    },
  },
};
</script>
<style lang="less" scoped>
@import '../../assets/css/var.less';
@import '../../assets/css/question.less';
.practice-item-option {
  margin-left: 25px;
  padding: 15px 0;
  label {
    font-size: 1.6rem;
    cursor: pointer;
    font-weight: normal;
    i {
      width: 26px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      color: #666;
      vertical-align: middle;
      display: inline-block;
      margin: 0 10px 3px 0;
      border: 1px solid #fff;
      font-style: normal;
      text-align: center;
    }
    input[type='checkbox'],
    input[type='radio'] {
      display: none;
    }
    input[type='checkbox'] + i {
      border-radius: 3px;
    }
    input[type='radio'] + i {
      border-radius: 20px;
    }
    input[type='checkbox']:checked + i,
    input[type='radio']:checked + i {
      background: #0195d3;
      border-color: #0195d3;
      color: #fff;
    }
    input[type='checkbox']:disabled + i,
    input[type='radio']:disabled + i {
      border-color: #fff;
    }
    input[type='checkbox']:checked:disabled + i,
    input[type='radio']:checked:disabled + i {
      background: #0195d3;
    }
    .item-text {
      display: inline-block;
      vertical-align: middle;
      /deep/img {
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
}
</style>
